module.exports = __webpack_public_path__ + "img/bg-summary-limit.80324dea.svg";